// @flow

import gql from 'graphql-tag';

import type { Dateable } from 'web-ssr/app/common/types';

export type AccountObject = {
  id: string,
  is_team_account: boolean,
  period_end: Dateable,
  owner: {
    id: string,
  },
  limits: {
    allotment: {
      zaps: {
        limit: string,
        count: number,
      },
      tasks: {
        limit: string,
        count: number,
      },
    },
  },
  logo_choices: Array<string>,
  plan: {
    name: string,
    metered_task_pricing: boolean,
  },
};

export type AccountResponse = {
  active_account_id: number,
  objects: AccountObject[],
};

export default gql`
  fragment AccountFragment on Account {
    active_account_id
    primary_id
    objects {
      id
      is_team_account
      period_end
      owner {
        id
      }
      logo_choices
      limits {
        allotment {
          zaps {
            limit
            count
          }
          tasks {
            limit
            count
          }
        }
      }
      plan {
        name
        metered_task_pricing
      }
    }
  }
`;
